import AContainer from "./ExtendedObjects/AContainer.js";

/**
 * NineSlice created by Jacob Caron 10/5/18
 */
export default class NineSlice extends AContainer
{
    /**
     * NOTE: The image used on this class should have an EVEN number of pixels!
     */
    constructor(scene, key, frame, top, bottom, left, right, width = -1, height = -1)
    {
        super(scene);

        this.key = key;
        this.frame = frame;
        this.slices = [[], [], []];
        this.origFrame = this.scene.textures.getFrame(key, frame);
        this.totalWidth = this.origFrame.width;
        this.totalHeight = this.origFrame.height;
        this.mainCutX = this.origFrame.cutX;
        this.mainCutY = this.origFrame.cutY;
        this.top = top;
        this.bottom = bottom;
        this.right = right;
        this.left = left;
        this.oX = .5;
        this.oY = .5;

        this.slices[0].push(this.cutImage(0, 0, left, top));
        this.slices[0].push(this.cutImage(left, 0, (this.width - left - right), top));
        this.slices[0].push(this.cutImage(this.width - right, 0, right, top));
        this.slices[1].push(this.cutImage(0, top, left, (this.height - bottom - top)));
        this.slices[1].push(this.cutImage(left, top, (this.width - left - right), (this.height - bottom - top)));
        this.slices[1].push(this.cutImage(this.width - right, top, right, (this.height - bottom - top)));
        this.slices[2].push(this.cutImage(0, (this.height - bottom), left, bottom));
        this.slices[2].push(this.cutImage(left, (this.height - bottom), (this.width - left - right), bottom));
        this.slices[2].push(this.cutImage(this.width - right, (this.height - bottom), right, bottom));

        this.setSize((width == -1) ? this.origFrame.width : width, (height == -1) ? this.origFrame.height : height);
    }

    set tint(value)
    {
        for(let x = 0; x < 3; x++)
        {
            for(let y = 0; y < 3; y++)
            {
                this.slices[x][y].tint = value;
            }
        }
    }

    cutImage(cutX, cutY, width, height)
    {
        if(width == 0 || height == 0) 
        {
            let blankObj = {};
            blankObj.setPosition = (x, y) => {};
            return blankObj;
        }

        let frame = this.origFrame.clone();
        frame.cutX = cutX + this.mainCutX;
        frame.cutY = cutY + this.mainCutY;
        frame.cutWidth = width;
        frame.cutHeight = height;
        frame.width = width;
        frame.height = height;
        frame.setTrim(width, height, this.width * .5 - width * .5, this.height * .5 - height * .5, width, height);
        frame.updateUVs();

        let image = this.create(0, 0, this.frame);
        image.frame = frame;
        image.alpha = 1;
        image.setOrigin(.5);

        return image;
    }

    setSize(width, height)
    {
        let middleHeight = height - this.top - this.bottom;
        let middleWidth = width - this.left - this.right;

        this.totalWidth = width;
        this.totalHeight = height;

        this.slices[0][1].displayWidth = middleWidth;
        this.slices[1][1].displayWidth = middleWidth;
        this.slices[2][1].displayWidth = middleWidth;
        this.slices[1][0].displayHeight = middleHeight;
        this.slices[1][1].displayHeight = middleHeight;
        this.slices[1][2].displayHeight = middleHeight;

        return this.updatePositions();
    }

    setWidth(value)
    {
        let middleWidth = value - this.left - this.right;
        this.totalWidth = value;

        this.slices[0][1].displayWidth = middleWidth;
        this.slices[1][1].displayWidth = middleWidth;
        this.slices[2][1].displayWidth = middleWidth;

        return this.updatePositions();
    }

    setHeight(value)
    {
        let middleHeight = value - this.top - this.bottom;
        this.totalHeight = value;
        
        this.slices[1][0].displayHeight = middleHeight;
        this.slices[1][1].displayHeight = middleHeight;
        this.slices[1][2].displayHeight = middleHeight;

        return this.updatePositions();
    }

    updatePositions()
    {
        let halfWidth = this.width * .5;
        let halfHeight = this.height * .5;
        let originOffsetX = (this.width * (1-this.oX)) - halfWidth;
        let originOffsetY = (this.height * (1-this.oY)) - halfHeight;
        let middleHeight = this.height - this.top - this.bottom;
        let middleWidth = this.width - this.left - this.right;
        let topY = -halfHeight + this.top * .5 + originOffsetY;
        let middleY = -halfHeight + this.top + middleHeight * .5 + originOffsetY;
        let bottomY = halfHeight - this.bottom * .5 + originOffsetY;
        let middleX = -halfWidth + this.left + middleWidth * .5 + originOffsetX;
        let leftX = -halfWidth + this.left * .5 + originOffsetX;
        let rightX = halfWidth - this.right * .5 + originOffsetX;

        this.slices[0][0].setPosition(leftX, topY);
        this.slices[0][1].setPosition(middleX, topY);
        this.slices[0][2].setPosition(rightX, topY);
        this.slices[1][0].setPosition(leftX, middleY);
        this.slices[1][1].setPosition(middleX, middleY);
        this.slices[1][2].setPosition(rightX, middleY);
        this.slices[2][0].setPosition(leftX, bottomY);
        this.slices[2][1].setPosition(middleX, bottomY);
        this.slices[2][2].setPosition(rightX, bottomY);

        return this;
    }

    setOrigin(x, y = -1)
    {
        this.oX = x;
        this.oY = (y == -1) ? x : y;

        return this.updatePositions();
    }

    set height(value){this.setHeight(value);}
    get height(){return this.totalHeight;}
    set width(value){this.setWidth(value);}
    get width(){return this.totalWidth;}
}